export default {
      id: "icon-favorites-usage",
      viewBox: "0 0 74 68",
      url: __webpack_public_path__ + "icons.svg#icon-favorites",
      toString: function () {
        return this.url;
      }
    }